$( document ).ready(function() {
    enquire.register("screen and (max-width:719px)", {
        match : function() {

            $('.help-box').insertAfter('.product-spec');
        },
        unmatch : function() {
            $('.help-box').appendTo('.product-gallery');
        }
    });
});
